export default {"src":"/_next/static/image/public/images/menu_epharmacy.eb0536b9d4060afda34cd79b777fa557.svg","height":47,"width":47};